import type { HttpTypes } from "@medusajs/types"
import { clx } from "@modules/common/components/ui"
import type React from "react"

type OptionSelectProps = {
  option: HttpTypes.StoreProductOption
  current: string | undefined
  updateOption: (optionId: string, value: string) => void
  title: string
  disabled: boolean
  invalid?: boolean
  "data-testid"?: string
}

const OptionSelect: React.FC<OptionSelectProps> = ({
  option,
  current,
  updateOption,
  title,
  "data-testid": dataTestId,
  disabled,
  invalid = false,
}) => {
  const filteredOptions = (option.values ?? []).map((value) => value.value)

  return (
    <fieldset className="flex flex-col gap-y-3" disabled={disabled}>
      <legend className="text-sm">{title} seç</legend>
      <div
        className="flex flex-wrap justify-between gap-2"
        data-testid={dataTestId}
      >
        {filteredOptions.map((value, index) => (
          <button
            type="button"
            onClick={() => updateOption(option.id, value)}
            key={value}
            aria-pressed={value === current}
            aria-invalid={invalid && index === 0 ? true : undefined}
            aria-label={`${title}: ${value}`}
            className={clx(
              "border-ui-border-base bg-ui-bg-subtle text-small-regular h-10 flex-1 rounded-rounded border p-2",
              {
                "border-ui-border-interactive": value === current,
                "hover:shadow-elevation-card-rest transition-shadow duration-150 ease-in-out":
                  value !== current,
              }
            )}
            disabled={disabled}
            data-testid="option-button"
          >
            {value}
          </button>
        ))}
      </div>
    </fieldset>
  )
}

export default OptionSelect
